import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Zkontroluj, zda uživatel již souhlasil s cookies
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <h3>🍪 Používání cookies</h3>
          <p>
            Tento web používá cookies pro správu nákupního košíku a uložení vašich kontaktních údajů 
            pro zlepšení uživatelského komfortu. Nepoužíváme analytické ani reklamní cookies.
          </p>
          <div className="cookie-consent-buttons">
            <button 
              className="cookie-consent-button accept"
              onClick={handleAccept}
            >
              Souhlasím
            </button>
            <button 
              className="cookie-consent-button reject"
              onClick={handleReject}
            >
              Odmítnout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
